/** Client-only hunt scan ring (Watch/Autopilot). Not on-chain — free public queries. */

export const HUNT_ACTIVITY_KEY = "motokomaker.v2.huntActivityLog";
const MAX_EVENTS = 50;

export type HuntScanActivity = {
	id: string;
	ts: number;
	mode: "watch" | "autopilot";
	matchCount: number;
	vaultIds: string[];
};

const listeners = new Set<() => void>();
let cache: HuntScanActivity[] | null = null;

function read(): HuntScanActivity[] {
	if (cache) return cache;
	try {
		const raw = localStorage.getItem(HUNT_ACTIVITY_KEY);
		if (!raw) {
			cache = [];
			return cache;
		}
		const parsed = JSON.parse(raw) as HuntScanActivity[];
		cache = Array.isArray(parsed) ? parsed : [];
	} catch {
		cache = [];
	}
	return cache;
}

function write(events: HuntScanActivity[]) {
	cache = events.slice(0, MAX_EVENTS);
	try {
		localStorage.setItem(HUNT_ACTIVITY_KEY, JSON.stringify(cache));
	} catch {
		/* ignore */
	}
	for (const l of listeners) l();
}

export function appendHuntScanActivity(ev: Omit<HuntScanActivity, "id">) {
	const next: HuntScanActivity = {
		...ev,
		id: `scan-${ev.ts}-${Math.random().toString(36).slice(2, 8)}`,
	};
	write([next, ...read()].slice(0, MAX_EVENTS));
}

export function loadHuntScanActivity(): HuntScanActivity[] {
	return read();
}

export function subscribeHuntScanActivity(cb: () => void) {
	listeners.add(cb);
	return () => listeners.delete(cb);
}

export function parseFeeKind(
	detail: string,
): "waiver" | "credits" | "cycles" | "none" | null {
	const m = /^fee=(waiver|credits|cycles|none)(?:;|$)/.exec(detail);
	if (!m) return null;
	return m[1] as "waiver" | "credits" | "cycles" | "none";
}

export function stripFeePrefix(detail: string): string {
	return detail.replace(/^fee=(waiver|credits|cycles|none);?/, "").trim();
}
